import { render, staticRenderFns } from "./SearchPrivacyAgree.vue?vue&type=template&id=a6d07870&"
import script from "./SearchPrivacyAgree.vue?vue&type=script&lang=js&"
export * from "./SearchPrivacyAgree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports